import styled from 'styled-components';
import TrashIcon from 'common/icons/Trash';

export const Trash = styled(TrashIcon)`
    max-width: 17px;
    color: ${({ theme }) => theme.palette.grayscale.black};
    &:hover {
        color: ${({ theme }) => theme.palette.danger.main};
    }
`;
